import { useState } from "react";
import { AutoComplete, Input } from "antd";
import Parser from "html-react-parser";
import { Link } from "react-router-dom";
import type { SelectProps } from "antd/es/select";
import { debounce } from "lodash-es";
import api from "@/api";
import { DocumentType, CardType, LinkType } from "./type";
import dataJson from "@/../public/data.json";
import { publicPath } from "@/utils/base";

import "./index.less";

const protocol = document.location.protocol;
const domain = window.location.host;
const prefix = "document";

function Document() {
  const { document } = dataJson;
  const [options, setOptions] = useState<SelectProps<object>["options"]>([]);
  const [searchValue, setSearchValue] = useState<string>("");

  const searchResult: (any: string) => void = (query: string) => {
    api
      .documentQuery({ keyword: query, limit: 30, page: 1 })
      .then((res:any) => {
        const resData = res.data;
        const resList = resData.datas.map((item: any) => {
          return {
            value: item.url,
            label: (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                }}
              >
                <span
                  style={{ width: "30%", marginRight: 100 }}
                  className="one-line-ellipsis"
                  title={item.navigationBar.replace(/<[^>]+>/g, "")}
                >
                  {item.navigationBar}
                </span>
                <span
                  style={{ width: "60%" }}
                  className="one-line-ellipsis"
                  title={item.highlightContent.replace(/<[^>]+>/g, "")}
                >
                  {Parser(item.highlightContent)}
                </span>
              </div>
            ),
          };
        });
        setOptions(resList);
      })
      .catch(() => {
        setOptions([]);
      });
  };
  const onSelect = (value: string) => {
    setSearchValue("");
    window.open(value, "_blank");
  };
  const handleSearch = (e: any) => {
    e ? searchResult(e) : setOptions([]);
  };

  return (
    <div className={prefix}>
      <div className={`${prefix}-search`} style={{ backgroundImage: `url(${document.document_bg})` }}>
        <div className={`${prefix}-search-inner`}>
          <div className={`${prefix}-search-title`}>{document.document_title}</div>
          <AutoComplete
            style={{ width: "100%", marginTop: 20 }}
            value={searchValue}
            options={options}
            maxLength={100}
            onSelect={onSelect}
            onSearch={debounce(handleSearch, 300)}
            onChange={(e) => {
              setSearchValue(e);
            }}
          >
            <Input size="large" placeholder="请输入关键词搜索文档" allowClear className={`${prefix}-input`} />
          </AutoComplete>
        </div>
      </div>
      {document.document_arr.map((item: DocumentType, index: number) => {
        return (
          <div className={`${prefix}-content`} key={index}>
            <div className={`${prefix}-content-title`}>{item.title}</div>
            <div
              className={`${prefix}-content-card`}
              style={{ width: item.list.length > 5 ? "100%" : item.list.length * 110 + 200 }}
            >
              {item.list.map((ele: CardType, idx: number) => {
                return (
                  <div className={`${prefix}-card-menu`} key={idx}>
                    <div className={`${prefix}-card-title`}>{ele.title}</div>
                    {ele.list.map((e: LinkType, i: number) => {
                      return (
                        <div key={i} className={`${prefix}-links`}>
                          <Link to={`${publicPath}/${e.url}`} target="_blank" className={`${prefix}-link`}>
                            {e.title}
                          </Link>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Document;
